import { createFileRoute } from "@tanstack/react-router";

import { RequirePermission } from "@/hooks/shared/CheckAuth";
import { CompanyFormPage } from "@/pages/dashboard/companies/form";

export const Route = createFileRoute("/_main/dashboard/companies/new")({
  component: () => (
    <RequirePermission action="companies.write">
      <CompanyFormPage />
    </RequirePermission>
  ),
});
